const requestPayment = {
    "d": {
        IsSuccess: true
    }
};
export default requestPayment;